

(function(){


const chart =
document.getElementById("silChartArea");


if(!chart) return;



const svg =
chart.querySelector(".sil-chart-svg");



const dogPath =
chart.querySelector(".sil-dog-line");



const catPath =
chart.querySelector(".sil-cat-line");



const tooltip =
document.getElementById("silTooltip");



const hoverLine =
document.getElementById("silHoverLine");



const dogPoint =
document.getElementById("silDogPoint");



const catPoint =
document.getElementById("silCatPoint");








/*
 数据逻辑
*/


function getTrendData(x){



if(x <= 470){


let progress =
(x-140)/(470-140);



return {


age:
progress < .5 ?
"1-2 Years":
"2 Years",



dog:
Math.round(
20+(55-20)*progress
),



cat:
Math.round(
15+(45-15)*progress
)



};



}



else{



let progress =
(x-470)/(780-470);



return {



age:
progress < .5 ?
"2-3 Years":
"3+ Years",




dog:
Math.round(
55+(80-55)*progress
),



cat:
Math.round(
45+(70-45)*progress
)



};



}



}









/*
 获取曲线真实坐标
*/


function getPoint(path,targetX){



let length =
path.getTotalLength();



let result={

x:0,

y:0,

distance:99999

};





for(
let i=0;
i<=250;
i++
){


let point =
path.getPointAtLength(
length*i/250
);



let distance =
Math.abs(
point.x-targetX
);





if(distance < result.distance){



result={

x:point.x,

y:point.y,

distance:distance

};



}



}



return result;


}









function update(e){



const rect =
svg.getBoundingClientRect();




let mouseX =
e.clientX -
rect.left;




let scale =
900 /
rect.width;




let x =
mouseX *
scale;




if(x<140)
x=140;



if(x>780)
x=780;








const dogPos =
getPoint(
dogPath,
x
);



const catPos =
getPoint(
catPath,
x
);








/*
 竖线
*/


hoverLine.style.display="block";



hoverLine.setAttribute(
"x1",
x
);



hoverLine.setAttribute(
"x2",
x
);








/*
 狗点
*/


dogPoint.style.display="block";



dogPoint.setAttribute(
"cx",
dogPos.x
);



dogPoint.setAttribute(
"cy",
dogPos.y
);








/*
 猫点
*/


catPoint.style.display="block";



catPoint.setAttribute(
"cx",
catPos.x
);



catPoint.setAttribute(
"cy",
catPos.y
);








const data =
getTrendData(x);






tooltip.innerHTML = `


<strong>
${data.age}
</strong>


<br>


🐶 Dogs:

<b>${data.dog}%</b>

oral care concern trend


<br>


🐱 Cats:

<b>${data.cat}%</b>

oral care concern trend


`;




/*
 显示数据框

 位置已经由CSS控制
 永远在图表上方

*/


tooltip.style.display="block";



}









function hide(){



tooltip.style.display="none";


hoverLine.style.display="none";


dogPoint.style.display="none";


catPoint.style.display="none";


}









/*
 PC 鼠标
*/


chart.addEventListener(
"mousemove",
update
);



chart.addEventListener(
"mouseleave",
hide
);









/*
 手机触摸

 只更新数据
 不移动tooltip

*/


chart.addEventListener(

"touchmove",

function(e){


const touch =
e.touches[0];


update(touch);



},

{
passive:true
}



);






chart.addEventListener(

"touchend",

function(){


hide();


}

);






})();





(()=>{


const lens = document.getElementById("compareLens");

const afterLayer = document.getElementById("afterLayer");

const divider = document.getElementById("compareDivider");



if(!lens || !afterLayer || !divider) return;



let dragging = false;






function updateComparison(clientX){



const rect = lens.getBoundingClientRect();




let position = clientX - rect.left;




position = Math.max(
0,
Math.min(position, rect.width)
);





const percent = 
(position / rect.width) * 100;





/*
滑杆位置
*/


divider.style.left = percent + "%";





/*
AFTER 从左向右增加
*/


afterLayer.style.width = percent + "%";



}





/* 鼠标 */

lens.addEventListener(
"pointerdown",
(e)=>{


dragging=true;


lens.setPointerCapture(e.pointerId);


updateComparison(e.clientX);


}

);







lens.addEventListener(
"pointermove",
(e)=>{


if(!dragging) return;


updateComparison(e.clientX);


}

);








lens.addEventListener(
"pointerup",
(e)=>{


dragging=false;


try{


lens.releasePointerCapture(e.pointerId);


}catch(err){}



}

);








lens.addEventListener(
"pointercancel",
()=>{


dragging=false;


}

);





})();




(function(){


function initSilIngredient(){


const section=document.querySelector(".sil-ingredients");


if(!section) return;



const cards=section.querySelectorAll(".sil-ing-card");


const image=section.querySelector("#silIngredientImage");



if(!cards.length || !image) return;




cards.forEach(card=>{


card.addEventListener("click",function(){



cards.forEach(c=>{

c.classList.remove("active");

});



this.classList.add("active");



const newImage=this.dataset.image;



if(newImage){



image.style.opacity="0";



setTimeout(function(){


image.src=newImage;


image.onload=function(){

image.style.opacity="1";

};


},200);



}



});


});


}





if(document.readyState==="loading"){


document.addEventListener(

"DOMContentLoaded",

initSilIngredient

);


}else{


initSilIngredient();


}



})();





document.querySelectorAll('.sil-faq-question')
.forEach(function(question){


question.addEventListener('click',function(){


let currentItem=this.parentElement;



document.querySelectorAll('.sil-faq-item')
.forEach(function(item){


if(item !== currentItem){


item.classList.remove('active');


}


});



currentItem.classList.toggle('active');



});


});




(()=>{const root=document.querySelector('#HealthzeriDentalDetails');root.querySelectorAll('.sil-ing-card').forEach(c=>{c.tabIndex=0;c.setAttribute('role','button');c.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();c.click()}})});const h=root.querySelector('.compare-handle');if(h){h.type='button';h.setAttribute('aria-label','Compare regular water and dental tablet water');h.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight'].includes(e.key))return;e.preventDefault();const a=root.querySelector('#afterLayer'),d=root.querySelector('#compareDivider');let p=parseFloat(a.style.width)||50;p=Math.max(0,Math.min(100,p+(e.key==='ArrowRight'?10:-10)));a.style.width=p+'%';d.style.left=p+'%'})}})();